export const cloneWorkflowGraph = (graph = {}) => {
  const clonedGraph = {};
  for (const id of Object.keys(graph || {})) {
    clonedGraph[id] = {
      ...graph[id],
      branches: Array.isArray(graph[id]?.branches) ? [...graph[id].branches] : []
    };
  }
  return clonedGraph;
};
